import { TextModuleFields, TextModuleProps } from '../types/textModuleContainer.types';
import { StringField, ImageField, TComponentParamsGeneral, THeadingTag, TImageField } from '../../../../types/types';
import { LinkField } from '@sitecore-jss/sitecore-jss-react/types/components/Link';

export class TextModuleModel {
  private readonly fields?: TextModuleFields;
  private readonly isEE: boolean;
  private readonly params?: TComponentParamsGeneral;

  constructor(props: TextModuleProps, isEE) {
    this.fields = props?.fields;
    this.isEE = isEE;
    this.params = props?.params;
  }

  get bodyText(): StringField | undefined {
    return this.fields?.message || this.fields?.bodyText;
  }

  get eyebrow(): StringField | undefined {
    return this.fields?.eyebrow;
  }

  get title(): StringField | undefined {
    return this.fields?.title;
  }

  get subtitle(): StringField | undefined {
    return this.fields?.subtitle;
  }

  get link1(): LinkField | undefined {
    return this.fields?.link || this.fields?.primaryLink;
  }

  get link2(): LinkField | undefined {
    return this.fields?.secondaryLink;
  }

  get image(): ImageField | undefined {
    return this.fields?.image;
  }

  get mobileImage(): ImageField | undefined {
    return this.fields?.mobileImage;
  }
  
  getLoadedImageDimension(isDesktop: boolean): { imageWidth: number } {
    let imageWidth = 0;

    let imageLoaded: TImageField | undefined = {};
    if (isDesktop) {
      imageLoaded = this?.image?.value?.src ? this.image : this.mobileImage;
    } else {
      imageLoaded = this?.mobileImage?.value?.src ? this.mobileImage : this.image;
    }
    imageWidth = Number(imageLoaded?.value?.width) || 0;
    return { imageWidth };
  }

  get textPosition(): StringField | undefined {
    return this.fields?.alignment?.fields?.Key || {value: 'center'};
  }

  get backgroundColor(): StringField | undefined {
    return this.fields?.backgroundColor?.fields?.Key;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get link1ExistsOrIsEE(): boolean {
    return !!((this.link1?.value?.text && this.link1?.value?.href) || this.isEE);
  }

  get link2ExistsOrIsEE(): boolean {
    return !!((this.link2?.value?.text && this.link2?.value?.href) || this.isEE);
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h3';
  }
}
